module.exports = __webpack_public_path__ + "static/media/condensed2GuildBadges.07562c48.svg";